App.controller('ProfileProtegesAddCtrl', ['$scope', '$sce', '$state', '$http', 'Config', '$mdDialog', 'profileProtegesService', '$stateParams', 'statesService', '$filter', '$q', function ($scope, $sce, $state, $http, Config, $mdDialog, profileProtegesService, $stateParams, statesService, $filter, $q) {
    $scope.stateParams = $stateParams;

    $scope.typeProteges = $scope.stateParams.typeProteges;

    $scope.page = 'profile_proteges_add';
    $scope.$emit('page', $scope.page);

    $scope.step = ($scope.typeProteges === 'CHILD') ? 'Dodaj podopiecznego' : 'Dodaj partnera/partnerkę';
    $scope.$emit('step', $scope.step);

    $scope.link = 'root.home.profile_proteges.lists';
    $scope.$emit('link', $scope.link);

    $scope.searchTextLocalization = null;
    $scope.selectedItemLocalization  = null;

    $scope.birthdate = new Date('01/01/2000');
    $scope.selectedItemLocalization  = null;
    $scope.citizenshipType = 'POLISH';

    $scope.$watchGroup(['identifier', 'birthdate'], function () {
        if ($scope.typeProteges === 'CHILD') {
            if ($scope.citizenshipType === 'POLISH') {
                if ($filter('isOver26FromIdentifier')($scope.identifier)) {
                    $scope.identifier = '';
                    $scope.showPopUp('', 'Błędne dane', 'Nie możesz dodać podopiecznego, który ma powyżej 26 lat.', '');
                    return 0;
                }
            } else {
                if ($filter('isOver26FromBirthdate')($scope.birthdate)) {
                    $scope.birthdate = '';
                    $scope.showPopUp('', 'Błędne dane', 'Nie możesz dodać podopiecznego, który ma powyżej 26 lat.', '');
                    return 0;
                }
            }
        }
    });

	$scope.add = function() {
		var vm = this;

        if (!vm.form.$valid) {
            return 0;
        }

		$scope.data = {
            email: $scope.email,
            firstName: $scope.firstName,
            lastName: $scope.lastName,
            identifier: ($scope.citizenshipType !== 'POLISH') ? $scope.id : $scope.identifier,
            identifierType: ($scope.citizenshipType === 'POLISH') ? 'PESEL' : 'OTHER',
            birthdate: ($scope.citizenshipType !== 'POLISH') ? new Date($scope.birthdate) : $filter('getDateFromIdentifier')($scope.identifier),
            phone: $scope.phone,
            citizenshipType: $scope.citizenshipType,
            otherCitizenship: $scope.otherCitizenship,
            address: {
                city: vm.form.city.$viewValue,
                street: $scope.street, 
                number: $scope.number, 
                apartment: $scope.apartment, 
                zipCode: $scope.zipCode
            },
            type: ($scope.typeProteges === 'CHILD' && $filter('isAdultFromIdentifier')($scope.identifier)) ? 'ADULT_CHILD' : $scope.typeProteges
        }

		profileProtegesService.addProtegesUser($scope.data).then(function (data) {
	        if (data && data.status === 200) {
                vm.form.$setPristine();
                vm.form.$setUntouched();
                vm.form.$submitted = false;

                if ($scope.typeProteges === 'CHILD') {
                    if ($scope.typeProteges === 'CHILD' && $filter('isAdultFromIdentifier')($scope.identifier)) {
                        $scope.showPopUp('', 'Pomyślnie zgłosiłeś podopiecznego', 'Wygląda na to, że jest już pełnoletni. Na jego e-mail przesłaliśmy link aktywacyjny, po kliknięciu którego będzie mógł się samodzielnie zalogować i korzystać z Portalu Pacjenta.', 'Wróć do listy podopiecznych', 'root.home.profile_proteges.lists');
                    } else {
                        $scope.showPopUp('', 'Dodano podopiecznego', 'Twój podopiecznego został pomyślnie dodany.', 'Wróć do listy podopiecznych', 'root.home.profile_proteges.lists');
                    }
                } else {
                    $scope.showPopUp('', 'Dodano partnera/partnerkę', 'Twój partner/partnerka został pomyślnie dodany.', 'Wróć do listy podopiecznych', 'root.home.profile_proteges.lists');
                }
            } else {
                if ($scope.typeProteges === 'CHILD') {
                    $scope.showPopUp('', 'Nie dodano podopiecznego', 'Dane są nieprawidłowe lub podopieczny już istnieje, spróbuj jeszcze raz.', '', '');
                } else {
                    $scope.showPopUp('', 'Nie dodano partnera/partnerki', 'Dane są nieprawidłowe lub partner/partnerka już istnieje, spróbuj jeszcze raz.', 'Wróć do listy podopiecznych', 'root.home.profile_proteges.lists');
                }
                
            }
	    });
	}

	$scope.showPopUp = function(ev, head, content, text, target) {
        $mdDialog.show({
            controller: PopUpInfoCtrl,
            templateUrl: Config.TEMPLATES_DIR + 'PopUp/info-big.html',
            targetEvent: ev,
            clickOutsideToClose: false,
            locals: {
                head: head,
                content: content,
                button: {
                    text: text,
                    target: target
                }
            }
        }).then(function(data) {
            console.log(data);
        }, function() {
            
        });
    }

    function PopUpInfoCtrl($scope, $mdDialog, locals) {
        $scope.locals = locals;

        $scope.hide = function() {
            $mdDialog.hide();
        };

        $scope.cancel = function() {
            $mdDialog.cancel();
        };

        $scope.confirm = function() {
            $mdDialog.hide($scope.locals);
        };
    }

    var getResults = function(query) {
        var deferred = $q.defer();

        statesService.dataCityLists({
            name: query
        }).then(function(data) {
            deferred.resolve(data.data);
        });

        return deferred.promise;
    };

    // ##### LOCALIZATION FILTER ##### //
    $scope.querySearchLocalization = function(query) {
        if (!query) {
            return;
        }
          
        return getResults(query).then(function(results) {
            return results;
        });
    };
}]);
